import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiAlertTriangle, FiCheckCircle, FiCopy } from "react-icons/fi";

interface ModalProps {
  active: boolean;
  setActive: any;
  status: "error" | "success" | undefined;
  protocolo?: string;
}

const ModalStatus: React.FC<ModalProps> = ({
  active,
  setActive,
  status,
  protocolo,
}) => {
  const statusSuccess = status === "success";
  const statusError = status === "error";

  const [agree, setAgree] = useState(false);

  return (
    <div className={active ? "modal is-active" : "modal"}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title is-flex">
            {statusSuccess && (
              <>
                <FiCheckCircle className="mr-2" />
                <span>Solicitação realizada com sucesso</span>
              </>
            )}

            {statusError && (
              <>
                <FiAlertTriangle className="mr-2 is-danger" />
                <span>Algum problema ocorreu na solicitação</span>
              </>
            )}
          </p>
        </header>
        <section className="modal-card-body">
          {statusSuccess && (
            <div className="my-4">
              <p className="mb-4">
                A sua solictação foi recebida. Agora as informações serão avaliadas e os documentos checados, em breve retornaremos o resultado do seu requerimento.
              </p>
              <p>
                É importante que você guarde o número de protocólo abaixo, com ele será possível consultar a situação do requerimento a qualquer na página inicial desse site.
              </p>
              <code
                className="is-flex is-justify-content-center is-align-items-center is-uppercase is-size-4 has-background-info-light has-text-info"
                style={{ minHeight: 100 }}
              >
                {protocolo}
              </code>
              <CopyToClipboard
                text={protocolo}
                onCopy={() => alert("Copiado para área de transferência")}
              >
                <button className="button mt-2 is-outlined">
                  <FiCopy />
                  <span className="ml-2">
                    Copiar para área de transferência.
                  </span>
                </button>
              </CopyToClipboard>
            </div>
          )}

          {statusError && (
            <div className="my-4">
              <p className="mb-4">
                Houve um problema durante a socilicitação do requerimento. Se o
                erro persistir entre em contato.
              </p>
            </div>
          )}
        </section>
        <footer className="modal-card-foot">
          {statusSuccess && (
            <div className="is-flex is-flex-direction-column is-align-items-flex-start">
              <label className="checkbox mb-4">
                <input
                  type="checkbox"
                  defaultChecked={agree}
                  onChange={(e) => setAgree(Boolean(e.target.checked))}
                />
                <span className="ml-2">
                  Eu li e Estou ciente das informações aqui passadas
                </span>
              </label>
              <button
                onClick={() => {
                  setActive(!open);
                  window.location.reload();
                }}
                className="field is-grouped button is-success"
                disabled={!agree}
              >
                <h5>Finalizar</h5>
              </button>
            </div>
          )}

          {statusError && (
            <>
              <button
                onClick={() => setActive(!open)}
                className="field is-grouped button is-danger"
              >
                <h5>Voltar</h5>
              </button>
            </>
          )}
        </footer>
      </div>
    </div>
  );
};

export default ModalStatus;
